export { default as PQueue } from 'p-queue';
export { castArray } from './array.ts';
export { asyncIterableCluster } from './asyncIterableCluster.ts';
export { circuitBreaker } from './circuitBreaker.ts';
export { deepMerge } from './deepMerge.ts';
export { createFailFastQueue } from './failFastQueue.ts';
export { firstTruthy } from './firstTruthy.ts';
export { isAccepted } from './is-accepted.ts';
export { jitter } from './jitter.ts';
export { measure } from './measure.ts';
export type { AnyObject, WithoutNull, WithoutNullish } from './nil.ts';
export { assertNotNull, hasAnyDefined, isNil, nonNullable, withoutNullish } from './nil.ts';
export { normalizeEmpty } from './normalizeEmpty.ts';
export { parseName } from './parseName.ts';
export { prunedObjectPlaceholder, pruneObjectToSize } from './pruneObjectToSize.ts';
export { parseSearchQuery } from './searchQuery.ts';
export { smsParts } from './sms.ts';
export { norwegianCompare, sort } from './sorting.ts';
export { plural, sanitizeWhitespaces, toSentence, toStr, truncate } from './string.ts';
export { tryEach } from './tryEach.ts';
export type { DeepPartial, MapValue, OptionalKeys, StringWithAutoComplete } from './types.ts';
export { unique } from './unique.ts';
export { withTimeout } from './withTimeout.ts';

/**
 * Exhaustive guard function for switch statements
 *
 * Having a switch with:
 *
 *     default: {
 *        exhaustiveGuard(parsed);
 *     }
 *
 * will ensure a compile error if a new case is added to the switch statement.
 */
export function exhaustiveGuard(x: never): never {
  throw new Error(`Reached forbidden guard function with unexpected value: ${JSON.stringify(x)}`);
}

export {
  assign,
  camel,
  capitalize,
  cluster,
  dash,
  debounce,
  diff,
  draw,
  fork,
  get,
  group,
  intersects,
  invert,
  isEmpty,
  isEqual,
  isNumber,
  isObject,
  isString,
  map,
  mapEntries,
  mapKeys,
  mapValues,
  max,
  memo,
  merge,
  min,
  omit,
  parallel,
  pick,
  random,
  range,
  reduce,
  retry,
  shake,
  shuffle,
  sift,
  sleep,
  snake,
  sum,
  template,
  toFloat,
  toInt,
  trim,
  tryit,
} from 'radash';
